<div>
  <div class="gb-dialog-header">
    <h1>{{ 'USERS.CHANGE_PASSWORD.TITLE' | translate }}</h1>

    <button mat-icon-button mat-dialog-close>
      <gb-icon icon="close"></gb-icon>
    </button>
  </div>

  <div class="gb-dialog-content">
    <gb-back-button (click)="back()" labelTranslateKey="USERS.CHANGE_PASSWORD.BACK"></gb-back-button>
    <p translate="USERS.CHANGE_PASSWORD.SUBTITLE"></p>

    <form [formGroup]="changePasswordForm">
      <gb-form-field
        [control]="new_password"
        type="password"
        labelTranslateKey="USERS.CHANGE_PASSWORD.NEW_PASSWORD"
      ></gb-form-field>
      <gb-form-field
        type="password"
        [control]="confirm_password"
        labelTranslateKey="USERS.CHANGE_PASSWORD.CONFIRM_PASSWORD"
        noMatchErrorTranslateKey="USERS.CHANGE_PASSWORD.NO_MATCH"
      ></gb-form-field>
    </form>
  </div>
  <div class="gb-dialog-actions-container">
    <button mat-flat-button (click)="submitForm()" [disabled]="(changePasswordLoaded$ | async) === false">
      <gb-button-loader [loaded$]="changePasswordLoaded$">
        <span>{{ 'SUBMIT' | translate }}</span>
      </gb-button-loader>
    </button>
  </div>
</div>
